import React from "react";
import { Globe, Type, Phone,Mail, MapPin, Info } from "lucide-react";

const AppSettings = ({ isEditMode, settings, setSettings, SettingGroup, isSidebarOpen }) => {
  return (
    <div className={`grid gap-6 w-full ${isSidebarOpen ? "grid-cols-1" : "grid-cols-1 xl:grid-cols-2"}`}>
      <SettingGroup title="App Identity" icon={Type}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Event Name</label>
            <input 
              type="text" 
              disabled={!isEditMode} 
              value={settings.appName}
              onChange={(e) => setSettings({...settings, appName: e.target.value})}
              className={`w-full px-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`}
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Organization</label>
            <input 
              type="text" 
              disabled={!isEditMode} 
              value={settings.companyName}
              onChange={(e) => setSettings({...settings, companyName: e.target.value})}
              className={`w-full px-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`}
            />
          </div>
        </div>
      </SettingGroup>

      <SettingGroup title="Contact & Official Links" icon={Globe}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col gap-1.5 md:col-span-2">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Official Website</label>
            <div className="relative">
              <Globe className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" size={14} />
              <input 
                type="text" 
                disabled={!isEditMode} 
                value={settings.officialWebsite} 
                onChange={(e) => setSettings({...settings, officialWebsite: e.target.value})}
                className={`w-full pl-10 pr-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
              />
            </div>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Email Support</label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" size={14} />
              <input 
                type="email" 
                disabled={!isEditMode} 
                value={settings.emailSupport} 
                onChange={(e) => setSettings({...settings, emailSupport: e.target.value})}
                className={`w-full pl-10 pr-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
              />
            </div>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Admin Contact</label>
            <div className="relative">
              <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" size={14} />
              <input 
                type="text" 
                disabled={!isEditMode} 
                value={settings.contactPerson} 
                onChange={(e) => setSettings({...settings, contactPerson: e.target.value})}
                className={`w-full pl-10 pr-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
              />
            </div>
          </div>
        </div>
      </SettingGroup>

      <SettingGroup title="Office Location" icon={MapPin}>
        <div className="flex flex-col gap-1.5 h-full">
          <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Full Address</label>
          <div className="relative flex-1">
            <MapPin className="absolute left-4 top-4 text-stone-400" size={14} />
            <textarea 
              rows="4" 
              disabled={!isEditMode} 
              value={settings.address} 
              onChange={(e) => setSettings({...settings, address: e.target.value})}
              className={`w-full h-full pl-10 pr-4 py-4 border rounded-xl text-sm outline-none resize-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
            />
          </div>
        </div>
      </SettingGroup>

      <SettingGroup title="About Event" icon={Info}>
        <div className="flex flex-col gap-1.5 h-full">
          <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Description</label>
          <div className="relative flex-1">
            <Info className="absolute left-4 top-4 text-stone-400" size={14} />
            <textarea 
              rows="4" 
              disabled={!isEditMode} 
              value={settings.aboutUs} 
              onChange={(e) => setSettings({...settings, aboutUs: e.target.value})}
              className={`w-full h-full pl-10 pr-4 py-4 border rounded-xl text-sm outline-none resize-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
            />
          </div>
        </div>
      </SettingGroup>
    </div>
  );
};

export default AppSettings;